import { Address } from '~api/address_book';
import type { Order } from '~api/tos';

import { Card } from '@ingrid/luterkort-react';

import { LocalizationKey, useTranslation } from '~src/i18n/use-translation';
import { AddressCard } from '~src/pages/shipment/details/address-card';
import { insertOnCondition } from '~src/utils/array';

interface Props {
  addresses: TransportOrderAddress[] | undefined;
}

export function Addresses({ addresses }: Props) {
  const { t } = useTranslation();

  if (!addresses) {
    return;
  }

  return (
    <Card.Wrapper>
      <Card.Header>{t('common.addresses')}</Card.Header>

      <Card.Grid css={{ width: '640px' }}>
        {addresses.map(item => (
          <AddressCard key={item.label} {...item} />
        ))}
      </Card.Grid>
    </Card.Wrapper>
  );
}

interface TransportOrderAddress {
  label: LocalizationKey;
  address: Address | undefined;
  email?: string | undefined;
  phone?: string | undefined;
}

export const getTransportOrderAddresses = (order: Order) => [
  ...insertOnCondition<TransportOrderAddress>(!!order.sender?.contact_info, {
    address: order.sender?.contact_info?.address,
    email: order.sender?.contact_info?.email,
    phone: order.sender?.contact_info?.phone,
    label: 'common.consignor',
  }),
  ...insertOnCondition<TransportOrderAddress>(!!order.receiver?.contact_info, {
    address: order.receiver?.contact_info?.address,
    email: order.receiver?.contact_info?.email,
    phone: order.receiver?.contact_info?.phone,
    label: 'common.consignee',
  }),
  ...insertOnCondition<TransportOrderAddress>(!!order.receiver?.destination?.address, {
    address: order.receiver?.destination?.address,
    email: order.receiver?.destination?.email,
    phone: order.receiver?.destination?.phone,
    label: 'common.delivery',
  }),
  ...insertOnCondition<TransportOrderAddress>(!!order?.receiver?.pickup_point_details?.address, {
    address: order.receiver?.pickup_point_details?.address,
    label: 'common.pickup',
  }),
];
